import Vue from "vue";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import { messages } from "./common/i18n/messages";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "ru",
  messages,
});

new Vue({
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
